import {
	Box,
	Button,
	Card,
	FormControl,
	IconButton,
	InputAdornment,
	SvgIcon,
	TextField,
	Typography,
} from '@mui/material'
import InstagramIcon from '@mui/icons-material/Instagram'
import FacebookIcon from '@mui/icons-material/Facebook'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { toastHelper } from '../../../util/toastHelper'
import styles from '../../settingsTabs/venderSettingTabs.module.scss'
import { updateProfile } from '../../../features/authSlice'
import LanguageOutlinedIcon from '@mui/icons-material/LanguageOutlined';

export const SocialProfilesCard = ({
	formData,
	setFormData,
	cardStyle,
	editable,
}) => {
	const dispatch = useDispatch()
	const [editing, setEditing] = useState(false)

	const isHttps = (url) => /^https?:\/\//i.test(url?.trim())

	const validHost = (url, allowedHosts) => {
		try {
		const u = new URL(isHttps(url) ? url : `https://${url}`)
		const host = u.hostname.toLowerCase()
		return allowedHosts.some((h) => host === h || host.endsWith(`.${h}`))
		} catch {
		return false
		}
	}

    const isValidUrl = (string) => {
        try {
            const url = new URL(string);
            return url.protocol === "http:" || url.protocol === "https:";
        } catch (error) {
            return false;
        }
    }

	const validateSocialLinks = () => {
		const { instagramLink, tiktokLink, facebookLink, websiteLink } = formData

		if (instagramLink?.trim()) {
		if (!validHost(instagramLink, ['instagram.com'])) {
			toastHelper('Instagram link must be an instagram.com URL', 'error')
			return false
		}
		}
		if (tiktokLink?.trim()) {
		if (!validHost(tiktokLink, ['tiktok.com'])) {
			toastHelper('TikTok link must be a tiktok.com URL', 'error')
			return false
		}
		}
		if (facebookLink?.trim()) {
		if (!validHost(facebookLink, ['facebook.com'])) {
			toastHelper('Facebook link must be a facebook.com URL', 'error')
			return false
		}
        }
        if(websiteLink && !isValidUrl(websiteLink)){
            toastHelper('Invalid url', 'error')
            return false
        }
		return true
	}

	let textFieldStyles = {
		bgcolor: 'white',
		margin: '0',
		'.MuiInputBase-input': {
			padding: '10px 10px 10px 0',
			fontSize: '14px',
			fontWeight: '400',
			color: '#313131',
		},

		'& label.MuiInputLabel-root': {
			color: '#7ca6bd',
		},
		'& .MuiInputBase-input.Mui-disabled': {
			color: '#313131',
			WebkitTextFillColor: 'black',
			opacity: 1,
			padding: '10px 10px 10px 0',
			fontSize: '14px',
			fontWeight: '400',
		},
		'& .MuiOutlinedInput-root': {
			borderRadius: '8px',
			'& > fieldset': {
				borderColor: '#DFE4EB !important',
			},
		},
	}

	const handleChange = (e, field) => {
		setFormData({ ...formData, [field]: e.target.value })
	}

	const handleSave = () => {
    if (!validateSocialLinks()) return
    dispatch(
      updateProfile({
        instagramLink: formData.instagramLink?.trim() || '',
        tiktokLink: formData.tiktokLink?.trim() || '',
        facebookLink: formData.facebookLink?.trim() || '',
        websiteLink: (formData.websiteLink || '').trim(),
      })
    )
    setEditing(false)
  }

	return (
		<Card
			sx={cardStyle}
			variant="outlined"
			className={`${styles.vendorCardBusinessInfo} ${styles.socialInfo} `}
		>
			<div className={styles.infoHeader}>
				<Typography
					variant="h5"
					gutterBottom
					sx={{ fontWeight: 'bold' }}
				>
					Social Profiles
				</Typography>
				{editable && (
					<Box>
						<IconButton
							component="label"
							className={styles.editIcon}
							disableRipple
							onClick={() => setEditing(true)}
						>
							<img
								src="/images/edit-icon.svg"
								alt="business pic"
							/>
						</IconButton>
						{editing && <Button onClick={handleSave}>Save</Button>}
					</Box>
				)}
			</div>
			<FormControl
				variant="standard"
				className={styles.socialInputFieldWrp}
				style={{
					display: 'flex',
					flexDirection: 'column',
					gap: '12px',
				}}
			>
				<TextField
					className={styles.socialInputField}
					disabled={!editing}
					// label="Instagram"
					placeholder="https://www.instagram.com/handle"
					sx={textFieldStyles}
					value={formData.instagramLink}
					onChange={(e) => handleChange(e, 'instagramLink')}
					slotProps={{
						input: {
							startAdornment: (
								<InputAdornment position="start">
									<InstagramIcon sx={{ color: '#7ca6bd' }} />
								</InputAdornment>
							),
						},
					}}
				/>
				<TextField
					className={styles.socialInputField}
					disabled={!editing}
					// label="Tiktok"
					placeholder="https://www.tiktok.com/handle"
					sx={textFieldStyles}
					value={formData.tiktokLink}
					onChange={(e) => handleChange(e, 'tiktokLink')}
					slotProps={{
						input: {
							startAdornment: (
								<InputAdornment position="start">
									<SvgIcon>
										<svg
											fill="#7ca6bd"
											viewBox="0 0 32 32"
											version="1.1"
											xmlns="http://www.w3.org/2000/svg"
										>
											<g
												id="SVGRepo_bgCarrier"
												strokeWidth="0"
											></g>
											<g
												id="SVGRepo_tracerCarrier"
												strokeLinecap="round"
												strokeLinejoin="round"
											></g>
											<g id="SVGRepo_iconCarrier">
												<title>tiktok</title>
												<path d="M16.656 1.029c1.637-0.025 3.262-0.012 4.886-0.025 0.054 2.031 0.878 3.859 2.189 5.213l-0.002-0.002c1.411 1.271 3.247 2.095 5.271 2.235l0.028 0.002v5.036c-1.912-0.048-3.71-0.489-5.331-1.247l0.082 0.034c-0.784-0.377-1.447-0.764-2.077-1.196l0.052 0.034c-0.012 3.649 0.012 7.298-0.025 10.934-0.103 1.853-0.719 3.543-1.707 4.954l0.020-0.031c-1.652 2.366-4.328 3.919-7.371 4.011l-0.014 0c-0.123 0.006-0.268 0.009-0.414 0.009-1.73 0-3.347-0.482-4.725-1.319l0.040 0.023c-2.508-1.509-4.238-4.091-4.558-7.094l-0.004-0.041c-0.025-0.625-0.037-1.25-0.012-1.862 0.49-4.779 4.494-8.476 9.361-8.476 0.547 0 1.083 0.047 1.604 0.136l-0.056-0.008c0.025 1.849-0.050 3.699-0.050 5.548-0.423-0.153-0.911-0.242-1.42-0.242-1.868 0-3.457 1.194-4.045 2.861l-0.009 0.030c-0.133 0.427-0.21 0.918-0.21 1.426 0 0.206 0.013 0.41 0.037 0.61l-0.002-0.024c0.332 2.046 2.086 3.59 4.201 3.59 0.061 0 0.121-0.001 0.181-0.004l-0.009 0c1.463-0.044 2.733-0.831 3.451-1.994l0.010-0.018c0.267-0.372 0.45-0.822 0.511-1.311l0.001-0.014c0.125-2.237 0.075-4.461 0.087-6.698 0.012-5.036-0.012-10.060 0.025-15.083z"></path>
											</g>
										</svg>
									</SvgIcon>
								</InputAdornment>
							),
						},
					}}
				/>
				<TextField
					className={styles.socialInputField}
					disabled={!editing}
					// label="Facebook"
					placeholder="https://www.facebook.com/handle"
					sx={textFieldStyles}
					value={formData.facebookLink}
					onChange={(e) => handleChange(e, 'facebookLink')}
					slotProps={{
						input: {
							startAdornment: (
								<InputAdornment position="start">
									<FacebookIcon sx={{ color: '#7ca6bd' }} />
								</InputAdornment>
							),
						},
					}}
				/>
				<TextField
					className={styles.socialInputField}
					disabled={!editing}
					// label="Facebook"
					placeholder="https://www.yourBusinessWebsite"
					sx={textFieldStyles}
					value={formData.websiteLink}
					onChange={(e) => handleChange(e, 'websiteLink')}
					slotProps={{
						input: {
							startAdornment: (
								<InputAdornment position="start">
									<LanguageOutlinedIcon sx={{ color: '#7ca6bd' }} />
								</InputAdornment>
							),
						},
					}}
				/>
			</FormControl>
		</Card>
	)
}
